import requests from '@/utils/requests';

/**
 * 添加导航接口
 * @param {*} data
 */
export function navigationAdd (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/navigation/add',
    method: 'post',
    data
  });
}

/**
 * 修改导航接口
 * @param {*} data
 */
export function navigationModify (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/navigation/modify',
    method: 'post',
    data
  });
}

/**
 * 删除导航接口
 * @param {*} data
 */
export function navigationDelete (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/navigation/delete',
    method: 'post',
    data
  });
}

/**
 * 导航列表接口
 * @param {*} data
 */
export function navigationList (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/navigation/list',
    method: 'post',
    data
  });
}

/**
 * 全部导航列表接口
 * @param {*} data
 */
export function navigationItems (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/navigation/items',
    method: 'post',
    data
  });
}

/**
 * 点击导航接口
 * @param {*} data
 */
export function navigationClick (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/navigation/click',
    method: 'post',
    data
  });
}

/**
 * 添加导航分类接口
 * @param {*} data
 */
export function navigationCategoryAdd (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/navigation/categoryAdd',
    method: 'post',
    data
  });
}

/**
 * 修改导航分类接口
 * @param {*} data
 */
export function navigationCategoryModify (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/navigation/categoryModify',
    method: 'post',
    data
  });
}

/**
 * 删除导航分类接口
 * @param {*} data
 */
export function navigationCategoryDelete (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/navigation/categoryDelete',
    method: 'post',
    data
  });
}

/**
 * 导航分类列表接口
 * @param {*} data
 */
export function navigationCategoryList (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/navigation/categoryList',
    method: 'post',
    data
  });
}

/**
 * 用户最近访问导航列表接口
 * @param {*} data
 */
export function navigationUserLatest (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/navigation/userLatest',
    method: 'post',
    data
  });
}

/**
 * 用户最常访问导航列表接口
 * @param {*} data
 */
export function navigationUserUsually (data) {
  return requests({
    serviceName: 'data-service',
    url: '/v1/navigation/userUsually',
    method: 'post',
    data
  });
}
